import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';

import { NativeMarket } from '@capgo/native-market';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { App } from '@capacitor/app';

interface AppUpdate {
    current: string;
    enabled: boolean;
    msg?: {
        title: string;
        msg: string;
        btn: string;
    };
    majorMsg?: {
        title: string;
        msg: string;
        btn: string;
    };
    minorMsg?: {
        title: string;
        msg: string;
        btn: string;
    };
}

@Injectable()
export class UpdateService {

    private interval;
    private alert;

    /**
     * Constructor
     */
    constructor(
        private http: HttpClient,
        private iab: InAppBrowser,
        private platform: Platform,
        private alertCtrl: AlertController
    ) {}

    /**
     * Startup: check app state
     */
    public async startup() {
        this.startCheck();
    }

    /**
     * Start version check
     */
    public async startCheck() {
        this.interval = setInterval( _ => {
            this.check();
        }, 1000 * 60 * 10);

        this.check();
    }   

    /**
     * Version check
     */
    public check() {
        this.http.get(environment.apiUrl + '/appversion').subscribe(async (info:AppUpdate) => {
            if (!info.enabled) {
                this.presentAlert(info.msg.title, info.msg.msg);
            } else {
                this.dismissAlert();
                const serverVersion = info.current.replace(/\s*\(.*?\)\s*/g, '').split('.');

                if (this.platform.is('hybrid')) {
                    const infos = await App.getInfo();
                    const splittedVersion = infos.version.replace(/\s*\(.*?\)\s*/g, '').split('.');
                    
                    if (Number(serverVersion[0]) > Number(splittedVersion[0])) {
                        this.presentAlert(info.majorMsg.title, info.majorMsg.msg, info.majorMsg.btn);
                    } else if (Number(serverVersion[0]) == Number(splittedVersion[0]) && Number(serverVersion[1]) > Number(splittedVersion[1])) {
                        this.presentAlert(info.majorMsg.title, info.majorMsg.msg, info.majorMsg.btn);
                    } else if (Number(serverVersion[0]) == Number(splittedVersion[0]) && Number(serverVersion[1]) == Number(splittedVersion[1]) && Number(serverVersion[2]) > Number(splittedVersion[2])) {
                        this.presentAlert(info.minorMsg.title, info.minorMsg.msg, info.minorMsg.btn, true);
                    }
                }
            }
        });
    }

    /**
     * Open App store
     */
    openAppStore() {
        if (this.platform.is('android')) {
            NativeMarket.openStoreListing({
                appId: 'com.begaym.app'
            });
        } else {
            this.iab.create('itms-apps://itunes.apple.com/app/id1623816795');
        }
    }

    /**
     * Present alert
     */
    async presentAlert(header, message, buttonText = '', allowClose = false) {
        if (!this.alert) {

            const buttons:any = [];

            if (buttonText != '') {
                buttons.push({
                    text: buttonText,
                    handler: () => {
                        this.openAppStore();
                        this.alert = null;
                        return false;
                    }
                });
            }

            if (allowClose) {
                buttons.push({
                    text: 'Fermer',
                    role: 'cancel',
                    handler: () => {
                        this.alert = null;
                    }
                });
            }

            this.alert = await this.alertCtrl.create({
                header,
                message,
                buttons,
                backdropDismiss: allowClose
            });
    
            await this.alert.present();
        }
    }

    /**
     * Present alert
     */
    async dismissAlert() {
        if (this.alert) {
            this.alertCtrl.dismiss({
                'dismissed': true
            });

            this.alert = null;
        }
    }
}
